export var Positioning;
(function (Positioning) {
    Positioning[Positioning["Cheapest"] = 1] = "Cheapest";
    Positioning[Positioning["NotCheapest"] = 2] = "NotCheapest";
    Positioning[Positioning["MostExpensive"] = 3] = "MostExpensive";
    Positioning[Positioning["CheaperMarketPrice"] = 4] = "CheaperMarketPrice";
    Positioning[Positioning["MoreExpensiveMarketPrice"] = 5] = "MoreExpensiveMarketPrice";
})(Positioning || (Positioning = {}));
//# sourceMappingURL=positioning.js.map